import { render, staticRenderFns } from "./DocumentLcl.vue?vue&type=template&id=714f97ca&scoped=true"
import script from "./DocumentLcl.vue?vue&type=script&lang=js"
export * from "./DocumentLcl.vue?vue&type=script&lang=js"
import style0 from "./DocumentLcl.vue?vue&type=style&index=0&id=714f97ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714f97ca",
  null
  
)

export default component.exports